import Vue from 'vue'

const self = Vue.prototype
import store from '../store'

export default {
  /**
   * Logging user by cred
   * @param user
   * @returns {Promise<any>}
   */
  loginUser(user) {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.login, user)
        .then(response => {
          localStorage.setItem('access_token', response.data.data.access_token)
          localStorage.setItem('refresh_token', response.data.data.refresh_token)
          // store.commit('setToken', response.data.data)
          self.axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.data.access_token
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  /**
   * Get user by access_token
   * @returns {Promise<any>}
   */
  getUser() {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.me)
        .then((resp) => {
          store.dispatch('createNewUser', resp.data.data.user)
          resolve(resp)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  /**
   * Auto logging when creating an application
   * @returns {Promise<any>}
   */
  autoLogin() {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.me)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })

  },
  /**
   * Logout user
   * @returns {Promise<any>}
   */
  logoutUser() {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.logout, {})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * Sign up user by cred
   * @param newUser
   * @returns {Promise<any>}
   */
  signUp(newUser) {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.registration, newUser)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

}
